import { Box, Flex, IconButton } from "@chakra-ui/react";
import { IconClose } from "components/icons/Icons";
import { useEffect, useState } from "react";
import { customerProfileMenu } from "./variables/profileMenu";
import CustomerProfileDetailsForm from "./components/CustomerProfileDetails";
import CustomerProfileMenu from "./components/CustomerProfileMenu";
import ProfilePhotoEditor from "./components/personal-detail/ProfilePhotoEditor";
import IndividualTeam from "./components/team/IndividualTeam";
import Billing from "./components/billing/Billing";
import { getLoggedInUser } from "network/helper";
import { useDispatch, useSelector } from "react-redux";
import {
  getBankRequest,
  getCardsRequest,
  getUserRequest,
} from "store/user/reducer";
import { isLoadingUserSelector } from "store/user/selector";
import PageLayout from "components/layout/PageLayout";

export default function CustomerProfileDetails(props: {
  isOpen: boolean;
  onClose: Function;
}) {
  const dispatch = useDispatch();
  const { isOpen, onClose } = props;
  const [selectMenu, setSelectMenu] = useState(customerProfileMenu[0]);
  useEffect(() => {
    if (isOpen === true) {
      if (localStorage.getItem("view_team")) {
        localStorage.removeItem("view_team");
        setSelectMenu(customerProfileMenu[2]);
      } else {
        setSelectMenu(customerProfileMenu[0]);
      }
    }
  }, [isOpen]);
  const isUserFetching = useSelector(isLoadingUserSelector);
  const user = getLoggedInUser();
  useEffect(() => {
    if (user?.user_id) {
      dispatch(
        getUserRequest({
          user_id: user.user_id,
        })
      );

      dispatch(getCardsRequest({ user_id: user.user_id }));
      dispatch(getBankRequest({ user_id: user.user_id }));
    }
  }, [user?.user_id]);

  return (
    <PageLayout>
      {!isUserFetching && (
        <>
        {/* Backdrop */}
        {isOpen && (
          <Box
            position="fixed"
            top="0"
            left="0"
            width="100vw"
            height="100vh"
            bg="rgba(0, 0, 0, 0.5)"
            zIndex="11400"
            transition="opacity 0.3s ease-in-out"
            opacity={isOpen ? 1 : 0}
          />
        )}
        
        {/* Account Details Panel */}
        <Box
          w={{
            base: "100vw",
            lg: "100vw",
            xl: "calc(100vw - 230px)",
            baseWidth: "calc(100vw - (100vw - 1440px) / 2 - 230px)",
          }}
          transition="transform 0.3s ease-in-out"
          transform={isOpen === true ? `translateX(0)` : `translateX(100%)`}
          minH="100vh"
          maxH="100vh"
          overflow={"auto"}
          position="fixed"
          bgColor="#FFF"
          zIndex="11500"
          boxShadow={isOpen ? "0px 4px 40px rgba(0, 0, 0, 0.1)" : "none"}
          boxSizing="border-box"
          top="0px"
          right="0px"
        >
        <Flex h="full" wrap="wrap">
          <IconButton
            position={{ md: "unset", base: "absolute" }}
            right="30px"
            top="30px"
            onClick={(e) => onClose()}
            aria-label="search"
            h={{ md: "52px", base: "30px" }}
            w={{ md: "52px", base: "30px" }}
            borderRadius="50%"
            bg="inherit"
            marginRight={{ xl: "60px", lg: "30px", base: "0px" }}
            _active={{
              bg: "inherit",
              transform: "none",
              borderColor: "transparent",
            }}
            _focus={{
              boxShadow: "none",
            }}
            icon={
              <IconClose
                w={{ md: "52px", base: "30px" }}
                h={{ md: "52px", base: "30px" }}
              />
            }
          />
          <Flex flex="1" direction="column">
            <CustomerProfileMenu
              selectedMenuItem={selectMenu}
              onMenuItemClick={(e: any) => setSelectMenu(e)}
            />
            
            <Box flex="1">
              {selectMenu.link === "account-details" && (
                <>
                  <ProfilePhotoEditor />
                  <CustomerProfileDetailsForm />
                </>
              )}
              {selectMenu.link === "team" && <IndividualTeam />}
              {selectMenu.link === "billing-reports" && <Billing />}
            </Box>
          </Flex>
        </Flex>
        </Box>
      </>
      )}
    </PageLayout>
  );
}
